import { render, staticRenderFns } from "./FAQs.vue?vue&type=template&id=e73f805a"
import script from "./FAQs.vue?vue&type=script&lang=js"
export * from "./FAQs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports